/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EventTypeConfigurationDto } from '../models';
// @ts-ignore
import type { UpdateEventTypeConfigurationRequestDto } from '../models';
/**
 * RestEventTypesApi - axios parameter creator
 */
export const RestEventTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Co dany typ wydarzenia ze sobą niesie: tagi, którymi zawęża podpowiedzi dań, szablon oferty, od którego zaczyna handlowiec, i szablon wydruku, w którym oferta idzie do klienta. Typ bez konfiguracji zwraca pustą listę tagów i puste wskazania szablonów — to poprawny stan, nie błąd. 
         * @summary Konfiguracja typu wydarzenia — tagi i domyślny szablon
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeConfiguration: async (dictionaryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('getEventTypeConfiguration', 'dictionaryId', dictionaryId)
            const localVarPath = `/api/dictionaries/event-types/{dictionaryId}/configuration`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pełna podmiana: `tagIds` jest stanem docelowym, więc odznaczenie tagu w UI go usuwa. `defaultProcessOfferId` musi wskazywać ofertę predefiniowaną (szablon) — zwykła oferta klienta jest odrzucana z kodem 400. `defaultOfferPrintId` musi wskazywać istniejący szablon wydruku. 
         * @summary Zapis konfiguracji typu wydarzenia
         * @param {number} dictionaryId 
         * @param {UpdateEventTypeConfigurationRequestDto} updateEventTypeConfigurationRequestDto Zapis konfiguracji typu wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeConfiguration: async (dictionaryId: number, updateEventTypeConfigurationRequestDto: UpdateEventTypeConfigurationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('updateEventTypeConfiguration', 'dictionaryId', dictionaryId)
            // verify required parameter 'updateEventTypeConfigurationRequestDto' is not null or undefined
            assertParamExists('updateEventTypeConfiguration', 'updateEventTypeConfigurationRequestDto', updateEventTypeConfigurationRequestDto)
            const localVarPath = `/api/dictionaries/event-types/{dictionaryId}/configuration`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventTypeConfigurationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEventTypesApi - functional programming interface
 */
export const RestEventTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEventTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Co dany typ wydarzenia ze sobą niesie: tagi, którymi zawęża podpowiedzi dań, szablon oferty, od którego zaczyna handlowiec, i szablon wydruku, w którym oferta idzie do klienta. Typ bez konfiguracji zwraca pustą listę tagów i puste wskazania szablonów — to poprawny stan, nie błąd. 
         * @summary Konfiguracja typu wydarzenia — tagi i domyślny szablon
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypeConfiguration(dictionaryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTypeConfiguration(dictionaryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEventTypesApi.getEventTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pełna podmiana: `tagIds` jest stanem docelowym, więc odznaczenie tagu w UI go usuwa. `defaultProcessOfferId` musi wskazywać ofertę predefiniowaną (szablon) — zwykła oferta klienta jest odrzucana z kodem 400. `defaultOfferPrintId` musi wskazywać istniejący szablon wydruku. 
         * @summary Zapis konfiguracji typu wydarzenia
         * @param {number} dictionaryId 
         * @param {UpdateEventTypeConfigurationRequestDto} updateEventTypeConfigurationRequestDto Zapis konfiguracji typu wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventTypeConfiguration(dictionaryId: number, updateEventTypeConfigurationRequestDto: UpdateEventTypeConfigurationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventTypeConfiguration(dictionaryId, updateEventTypeConfigurationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEventTypesApi.updateEventTypeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEventTypesApi - factory interface
 */
export const RestEventTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEventTypesApiFp(configuration)
    return {
        /**
         * Co dany typ wydarzenia ze sobą niesie: tagi, którymi zawęża podpowiedzi dań, szablon oferty, od którego zaczyna handlowiec, i szablon wydruku, w którym oferta idzie do klienta. Typ bez konfiguracji zwraca pustą listę tagów i puste wskazania szablonów — to poprawny stan, nie błąd. 
         * @summary Konfiguracja typu wydarzenia — tagi i domyślny szablon
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeConfiguration(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeConfigurationDto> {
            return localVarFp.getEventTypeConfiguration(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pełna podmiana: `tagIds` jest stanem docelowym, więc odznaczenie tagu w UI go usuwa. `defaultProcessOfferId` musi wskazywać ofertę predefiniowaną (szablon) — zwykła oferta klienta jest odrzucana z kodem 400. `defaultOfferPrintId` musi wskazywać istniejący szablon wydruku. 
         * @summary Zapis konfiguracji typu wydarzenia
         * @param {number} dictionaryId 
         * @param {UpdateEventTypeConfigurationRequestDto} updateEventTypeConfigurationRequestDto Zapis konfiguracji typu wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeConfiguration(dictionaryId: number, updateEventTypeConfigurationRequestDto: UpdateEventTypeConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEventTypeConfiguration(dictionaryId, updateEventTypeConfigurationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEventTypesApi - interface
 */
export interface RestEventTypesApiInterface {
    /**
     * Co dany typ wydarzenia ze sobą niesie: tagi, którymi zawęża podpowiedzi dań, szablon oferty, od którego zaczyna handlowiec, i szablon wydruku, w którym oferta idzie do klienta. Typ bez konfiguracji zwraca pustą listę tagów i puste wskazania szablonów — to poprawny stan, nie błąd. 
     * @summary Konfiguracja typu wydarzenia — tagi i domyślny szablon
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEventTypeConfiguration(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeConfigurationDto>;

    /**
     * Pełna podmiana: `tagIds` jest stanem docelowym, więc odznaczenie tagu w UI go usuwa. `defaultProcessOfferId` musi wskazywać ofertę predefiniowaną (szablon) — zwykła oferta klienta jest odrzucana z kodem 400. `defaultOfferPrintId` musi wskazywać istniejący szablon wydruku. 
     * @summary Zapis konfiguracji typu wydarzenia
     * @param {number} dictionaryId 
     * @param {UpdateEventTypeConfigurationRequestDto} updateEventTypeConfigurationRequestDto Zapis konfiguracji typu wydarzenia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEventTypeConfiguration(dictionaryId: number, updateEventTypeConfigurationRequestDto: UpdateEventTypeConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEventTypesApi - object-oriented interface
 */
export class RestEventTypesApi extends BaseAPI implements RestEventTypesApiInterface {
    /**
     * Co dany typ wydarzenia ze sobą niesie: tagi, którymi zawęża podpowiedzi dań, szablon oferty, od którego zaczyna handlowiec, i szablon wydruku, w którym oferta idzie do klienta. Typ bez konfiguracji zwraca pustą listę tagów i puste wskazania szablonów — to poprawny stan, nie błąd. 
     * @summary Konfiguracja typu wydarzenia — tagi i domyślny szablon
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventTypeConfiguration(dictionaryId: number, options?: RawAxiosRequestConfig) {
        return RestEventTypesApiFp(this.configuration).getEventTypeConfiguration(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pełna podmiana: `tagIds` jest stanem docelowym, więc odznaczenie tagu w UI go usuwa. `defaultProcessOfferId` musi wskazywać ofertę predefiniowaną (szablon) — zwykła oferta klienta jest odrzucana z kodem 400. `defaultOfferPrintId` musi wskazywać istniejący szablon wydruku. 
     * @summary Zapis konfiguracji typu wydarzenia
     * @param {number} dictionaryId 
     * @param {UpdateEventTypeConfigurationRequestDto} updateEventTypeConfigurationRequestDto Zapis konfiguracji typu wydarzenia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEventTypeConfiguration(dictionaryId: number, updateEventTypeConfigurationRequestDto: UpdateEventTypeConfigurationRequestDto, options?: RawAxiosRequestConfig) {
        return RestEventTypesApiFp(this.configuration).updateEventTypeConfiguration(dictionaryId, updateEventTypeConfigurationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

